import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-fangdajing",
  "use": "icon-icon-fangdajing-usage",
  "viewBox": "0 0 16.7 16.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16.7 16.9\" id=\"icon-icon-fangdajing\">\r\n<title>资源 1</title>\r\n<g id=\"icon-icon-fangdajing_图层_2_1_\">\r\n\t<g id=\"icon-icon-fangdajing_图层_1-2\">\r\n\t\t<g>\r\n\t\t\t<path d=\"M8.3,16.6C3.7,16.6,0,12.9,0,8.3S3.7,0,8.3,0s8.3,3.7,8.3,8.3S12.9,16.6,8.3,16.6z M8.3,2C4.8,2,2,4.8,2,8.3\r\n\t\t\t\ts2.8,6.3,6.3,6.3s6.3-2.8,6.3-6.3S11.8,2,8.3,2z\" />\r\n\t\t</g>\r\n\t\t<g>\r\n\t\t\t<path d=\"M10.4,6.8L10.4,6.8C9.5,5.6,7.9,5.4,6.8,6.3L5.6,4.7C6.5,4,7.7,3.6,8.9,3.8c1.2,0.1,2.3,0.7,3,1.7L12,5.6L10.4,6.8z\" />\r\n\t\t</g>\r\n\t\t<g>\r\n\t\t\t<path d=\"M14.1,16.9c-0.3,0-0.6-0.1-0.8-0.4l-1.2-1.6c-0.3-0.4-0.2-1.1,0.2-1.4c0.4-0.3,1.1-0.2,1.4,0.2l1.2,1.6\r\n\t\t\t\tc0.3,0.4,0.2,1.1-0.2,1.4C14.5,16.8,14.3,16.9,14.1,16.9z\" />\r\n\t\t</g>\r\n\t</g>\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-fangdajing.svg
// module id = e/WR
// module chunks = 72